export default __webpack_public_path__ + "static/media/icon-more.9ee4ab83.svg";